<cargoes-title title="{{'menu.smarttools.usefulLinks.ftaAdvisory' | translate }}"></cargoes-title>
<nz-layout class="fta-advisory-box">
  <nz-tag class="mr0" nzColor="blue">
    <span style="color: #0080AF; white-space: normal;">{{'app.smarttools.disclaimer' | translate}} {{'app.smarttools.ftaDisclaimer' | translate}}</span>
  </nz-tag>
  <nz-card [nzBordered]="true" nzTitle="" class="input-form-card">
    <form nz-form [formGroup]="ftaAdvisorForm">
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
          <nz-form-item class="pr-md">
            <nz-form-label nz-row nzFor="countryOfOrigin" nzSpan="24">
              {{'app.duty-calculator.label.origin' | translate}}
            </nz-form-label>
            <nz-form-control nz-row>
              <nz-input-group>
                <nz-select [nzSize]="'default'" [nzPlaceHolder]="'app.duty-calculator.label.origin'|translate"
                  nzShowSearch formControlName="originCountryIso" nzAllowClear [nzCustomTemplate]="defaultTemplate">
                  <nz-option nzCustomContent *ngFor="let option of (rdmList$ | async ).get('tred3207')" [nzLabel]="option.label" [nzValue]="option.code">
                    <svg height="14px" width="20px" class="mr-md">
                      <use attr.xlink:href="{{CommonConstants.countryFlagPath+option.attributes['iconName']}}"></use>
                    </svg> {{option.label}}
                  </nz-option>
                </nz-select>
                <ng-template #defaultTemplate let-selected>
                  <svg height="14px" width="20px" class="mr-md">
                    <use attr.xlink:href="{{CommonConstants.countryFlagPath+selected.nzValue}}"></use>
                  </svg>{{ selected.nzLabel }}
                </ng-template>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
          <nz-form-item class="pr-md">
            <nz-form-label nz-row nzRequired nzFor="destination" nzSpan="24">
              {{'app.duty-calculator.label.destination' | translate}}</nz-form-label>
            <nz-form-control nz-row [nzErrorTip]="'app.duty-calculator.fields.required' | translate">
              <nz-input-group>
                <nz-select [nzSize]="'default'" [nzPlaceHolder]="'app.duty-calculator.label.destination'|translate"
                  nzShowSearch formControlName="destinationCountryIso" nzAllowClear [nzCustomTemplate]="defaultTemplate">
                  <nz-option nzCustomContent *ngFor="let option of (rdmList$ | async ).get('tred3207')" [nzLabel]="option.label" [nzValue]="option.code">
                    <svg height="14px" width="20px" class="mr-md">
                      <use attr.xlink:href="{{CommonConstants.countryFlagPath+option.attributes['iconName']}}"></use>
                    </svg> {{option.label}}
                  </nz-option>
                </nz-select>
                <ng-template #defaultTemplate let-selected>
                  <svg height="14px" width="20px" class="mr-md">
                    <use attr.xlink:href="{{CommonConstants.countryFlagPath+selected.nzValue}}"></use>
                  </svg>
                  {{ selected.nzLabel }}
                </ng-template>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
          <nz-form-item class="pr-md">
            <nz-form-label nz-row nzRequired nzFor="advisoryType" nzSpan="24">
              {{'app.fta-advisory.label.advisoryType.type' | translate}}
            </nz-form-label>
            <nz-form-control nz-row [nzErrorTip]="'app.duty-calculator.fields.required' | translate">
              <nz-radio-group formControlName="productBased" nzButtonStyle="solid">
                <label nz-radio-button nzValue="true">{{'app.fta-advisory.label.advisoryType.product' | translate}}</label>
                <label nz-radio-button nzValue="false">{{'app.fta-advisory.label.advisoryType.country' | translate}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" *ngIf="productAdvisoryType">
          <nz-form-label nz-row nzRequired nzFor="advisoryType" nzSpan="24">
            {{'app.duty-calculator.label.hs-code' | translate}}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="'app.label.select.hsCode' | translate">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
              <input #hsCodeValue nz-input id="hsCode" formControlName="hsCode" placeholder="{{'app.duty-calculator.label.hs-code' | translate}}">
            </nz-input-group>
            <ng-template #suffixIconButton>
              <button nz-button nzType="primary" nzSearch (click)="tariffFinder(hsCodeValue.value)" [disabled]="disable"><i nz-icon nzType="search"></i>
                {{'app.label.lookup'|translate}}
              </button>
            </ng-template>
          </nz-form-control>
        </div>
      </div>
      <!-- <nz-form-item *ngIf="recaptchaEnable">
        <nz-form-control [nzErrorTip]="'app.duty-calculator.fields.required' | translate">
          <re-captcha formControlName="recaptchaReactive"></re-captcha>
        </nz-form-control>
      </nz-form-item> -->
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
          <nz-form-item>
            <nz-form-control class="centerButton">
              <button nz-button [nzType]="'primary'"
                [nzLoading]="calculatingFtaAdvisory" (click)="searchFtaAdvisory(1)" [disabled]="!ftaAdvisorForm.valid">{{'app.label.search' | translate}}</button>
              <button class="ml" nz-button [nzType]="'default'"
                 (click)="resetButton()" [disabled]="!ftaAdvisorForm.valid">{{'app.label.reset' | translate}}</button>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <nz-divider class="mt-sm mb0"></nz-divider>
      <nz-table #basicTable [nzTemplateMode]="viewModel.hsCodeList.length > 0" [nzData]="viewModel.hsCodeList"
          [(nzPageIndex)]="searchTablePageIndex" [nzFrontPagination]="false" [nzTotal]="totalElements" [(nzPageSize)]="pageSize" [nzShowPagination]="true" (nzPageIndexChange)="searchFtaAdvisory($event)" [nzHideOnSinglePage]="true" class="mt-lg clear-both"
          *ngIf="viewModel.hsCodeList.length > 0">
        <thead>
          <tr>
            <th nzWidth="150px">{{'app.label.name' | translate}}</th>
            <th nzWidth="250px">{{'app.label.description' | translate}}</th>
            <th nzWidth="100px">{{'app.label.inspection.action' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i=index">
            <td>{{ data?.shortName }}</td>
            <td>{{ data?.longName }}</td>
            <td><a ><i nz-icon nzType="select" (click)="showFTADetails(data.tariffCodeId, data.longName, 1)" nzTheme="outline" nz-tooltip nzTitle="'app.label.getDetails' | translate"></i> </a></td>
          </tr>
        </tbody>
      </nz-table>
    </form>

    <nz-modal [(nzVisible)]="isVisible" [nzTitle]="FTATitle | translate" (nzOnCancel)="handleCancel()" [nzStyle]="{ width: '1000px' }" [nzFooter]="modalFooter">
      <ng-container *nzModalContent>
        <div nz-row *ngIf="!originCountrySelected">
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <nz-form-label nz-row class="full-width" nzFor="countryOfOrigin" nzSpan="24"> {{'app.duty-calculator.label.origin' | translate}} </nz-form-label>
            <nz-select nz-row class="full-width" [nzSize]="'default'" [nzPlaceHolder]="'app.duty-calculator.label.origin'|translate" nzShowSearch nzAllowClear [ngModel]="selectedCountry" (ngModelChange)="getSelectedCountryCode($event)">
              <nz-option *ngFor="let countryData of countryList" [nzLabel]="countryData.label" [nzValue]="countryData.iso">
              </nz-option>
            </nz-select>
          </div>
        </div>
        <nz-table [nzLoading]="loadingFtaDetails" #ftaDetailsTable [nzTemplateMode]="viewModelForFTADetailsById.ftaDetailsList.length > 0" [nzData]="viewModelForFTADetailsById.ftaDetailsList" [(nzPageIndex)]="pageIndex" [nzFrontPagination]="false" [nzTotal]="totalFTADetailsElements" [(nzPageSize)]="pageSize" [nzShowPagination]="true" (nzPageIndexChange)="changePagination($event, searchHSCode, searchDescription)" [nzHideOnSinglePage]="true" class="mt-lg clear-both">
          <thead>
            <tr *ngIf="!productAdvisoryType">
              <th nzWidth="2%"></th>
              <th nzWidth="20%">
                <input type="text" nz-input placeholder="{{'app.label.search' | translate}} {{'app.duty-calculator.label.hs-code' | translate}} " [(ngModel)]="searchHSCode">
              </th>
              <th nzWidth="98%">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                  <input class="input-box" type="text" nz-input placeholder="{{'app.label.search' | translate}} {{'app.label.description' | translate}}" [(ngModel)]="searchDescription" (keyup.enter)="search(searchHSCode, searchDescription)">
                </nz-input-group>
                <ng-template #suffixIconButton>
                  <button nz-button nzSize="default" nzType="primary" (click)="search(searchHSCode, searchDescription)" class="search-button">{{'app.label.search' | translate}}</button>
                  <button nz-button nzSize="default" (click)="reset()">{{'app.label.reset' | translate}}</button>
                </ng-template>
              </th>
            </tr>
            <tr>
              <th nzWidth="2%"></th>
              <th nzWidth="20%">{{'app.duty-calculator.label.hs-code' | translate}}</th>
              <th nzWidth="98%">{{'app.label.description' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-data [ngForOf]="ftaDetailsTable.data">
              <tr>
                <td [(nzExpand)]="data.expand" (click)="showCountryDetails(data.hscode, data.expand, data.tariffCode, data.index)"></td>
                <td>{{ data?.hscode }}</td>
                <td>
                  {{ data?.fullDescription}}
                  <span *ngIf="data?.notes1" (click)="showNotesDetails(data.hscode)" nz-tooltip [nzTooltipTitle]="'app.duty-calculator.label.clickToExpand' | translate" style="cursor: pointer;">
                    <i nz-icon class="info-icon" nzType= "exclamation-circle" *ngIf="showFTANotesDescription !== data.hscode"></i>
                  </span>
                  <span *ngIf="showFTANotesDescription === data.hscode" @fadeInOut style="color: #0080AF; white-space: normal;">
                    <br *ngIf="data?.notes1"><p [ngClass]="shake? 'shakeText' : ''">{{ data?.notes1 }}</p>
                    <br *ngIf="data?.notes2"><p [ngClass]="shake? 'shakeText' : ''">{{ data?.notes2 }}</p>
                    <br *ngIf="data?.notes3"><p [ngClass]="shake? 'shakeText' : ''">{{ data?.notes3 }}</p>
                    <br *ngIf="data?.notes4"><p [ngClass]="shake? 'shakeText' : ''">{{ data?.notes4 }}</p>
                  </span>
                </td>
              </tr>
              <tr [nzExpand]="data.expand">
                <span *ngIf="!originCountryCode && !originCountrySelected">{{ 'app.label.select.originCountry' | translate }}</span>
                <nz-table #innerTable nzBordered [ngClass]="originCountrySelected ? 'innerTableCountrySelected' : 'innerTableNoCountrySelected'" [nzData]="innerTableMap.get(data.index)" nzSize="middle" [nzShowPagination]="false" *ngIf="innerTableMap.get(data.index)">
                  <thead>
                    <tr>
                      <th>{{'app.label.name' | translate}}</th>
                      <th>{{'app.label.type' | translate}}</th>
                      <th>{{'app.label.percentage' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let innerdata of innerTable.data">
                      <td>{{ innerdata?.longName }} - ({{ innerdata?.shortName }})</td>
                      <td>{{ innerdata?.type }}</td>
                      <td *ngIf="innerdata?.percentage <= 100">{{ innerdata?.percentage }} %</td>
                      <td *ngIf="innerdata?.percentage > 100" (click)="shakeText()"><i nz-icon class="error-icon" nzType= "exclamation-circle" (click)="showNotesDetails(data.hscode)"></i></td>
                    </tr>
                  </tbody>
                </nz-table>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
      </ng-container>
      <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">{{'app.label.cancel' | translate}}</button>
      </ng-template>
    </nz-modal>
  </nz-card>
</nz-layout>